import React, {useState} from "react";
import StackedContentContainer from "../ContentContainer";
import DispatchCalendar from "../DispatchCalendar";
import DatePicker from "react-datepicker";
import {Col, Pagination, Row as BRow} from "react-bootstrap";
import {addDays, format} from "date-fns";

export const DispatchPage: React.FC = () => {

    const [selectedDate, setSelectedDate] = useState(new Date())

    return(
        <StackedContentContainer title={"Dispatch Calendar"}>
            <BRow className={'mx-3'}>
                <Pagination className={"justify-content-center"}>
                    <Col xs lg={2} className={"d-flex align-items-start flex-column"}>
                        <Pagination.First className={"w-auto"} onClick={()=>setSelectedDate(addDays(selectedDate,-1))}/>
                    </Col>
                    <Col md={'auto'} className={"ml-3 my-auto"}>
                        <DatePicker
                            id="start_date"
                            className={'datetime-select form-control'}
                            dateFormat={"dd-MM-yy"}
                            selected={
                                new Date(selectedDate)
                            }
                            onChange={(date: Date) => {
                                if (date) {
                                    setSelectedDate(date)
                                }
                            }}
                        />
                    </Col>
                    <Col xs lg={2} className={"d-flex align-items-end flex-column"}>
                        <Pagination.Last className={"w-auto"} onClick={()=>setSelectedDate(addDays(selectedDate,1))}/>
                    </Col>
                </Pagination>
            </BRow>
            <DispatchCalendar after_date={format(selectedDate, 'yyyy-MM-dd')}/>
        </StackedContentContainer>
    )
}